'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFortAwesome = function FaFortAwesome(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.8 22.5v-5q0-0.4-0.4-0.4h-2.1q-0.4 0-0.4 0.4v5q0 0.4 0.4 0.4h2.1q0.4 0 0.4-0.4z m11.4 0v-5q0-0.4-0.3-0.4h-2.2q-0.3 0-0.3 0.4v5q0 0.4 0.3 0.4h2.2q0.3 0 0.3-0.4z m11.4 0.7v16.8h-14.2v-7.1q0-1.8-1.3-3.1t-3-1.2-3.1 1.2-1.2 3.1v7.1h-14.3v-16.8q0-0.3 0.4-0.3h2.1q0.4 0 0.4 0.3v2.5h2.8v-13.9q0-0.4 0.4-0.4h2.1q0.4 0 0.4 0.4v2.5h2.8v-2.5q0-0.4 0.4-0.4h2.1q0.4 0 0.4 0.4v2.5h2.8v-2.5q0-0.4 0.4-0.4h0.4v-8.7q-0.8-0.5-0.8-1.3 0-0.6 0.5-1t1-0.4 1 0.4 0.4 1q0 0.8-0.7 1.3v0.2h6.1q0.3 0 0.3 0.3v5q0 0.4-0.3 0.4h-6.1v2.8h0.3q0.4 0 0.4 0.4v2.5h2.9v-2.5q0-0.4 0.3-0.4h2.2q0.3 0 0.3 0.4v2.5h2.9v-2.5q0-0.4 0.3-0.4h2.2q0.3 0 0.3 0.4v13.9h2.9v-2.5q0-0.3 0.3-0.3h2.2q0.3 0 0.3 0.3z' })
        )
    );
};

exports.default = FaFortAwesome;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/fort-awesome.js
// module id = 1398
// module chunks = 0